import styled from 'styled-components'
import MaskedInput from 'react-input-mask'

import { fontFamilyMono, mobileMedia } from '~/lib/theme'

export const AdditionalAction = styled.button`
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #5165ee;
  border: none;
  background: transparent;
  text-align: left;
`

export const DisclaimerContainer = styled.div`
  position: relative;
  margin-top: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: row nowrap;
  & > p {
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    margin: 0;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #a7afd9;
  }
  & a {
    color: #a7afd9;
    text-decoration: underline #a7afd9;
  }

  ${mobileMedia} {
    position: static;
    margin-top: 32px;
  }
`

export const Container = styled.div`
  padding: 24px 16px 16px 16px;
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
`

export const Disclaimer = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #a7afd9;
  line-height: 1.5;
  margin-bottom: 24px;
`

export const StyledMaskInput = styled(MaskedInput)`
  ${fontFamilyMono};
  position: relative;
  display: block;
  width: 100%;
  height: 72px;
  padding: 0 48px 0 16px;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: black;

  ::placeholder {
    color: #a7afd9;
  }

  background-color: #edeffd;
  border-radius: 8px;
  border: solid 1px #edeffd;

  &:focus {
    border: solid 1px #c6ccf9;
    opacity: unset;
  }
`

const LoginButtonBase = styled.button`
  position: relative;
  height: 68px;
  background-color: #ea417f;
  border: none;
  border-radius: 4px;

  margin: 0 16px 16px 16px;
  padding: 0 8px;

  font-family: inherit;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.67;
  text-align: center;
  color: #ffffff;
  text-overflow: ellipsis;
  overflow: hidden;

  transition: all 150ms;
  -webkit-appearance: none; // important for iOs devices

  cursor: pointer;

  &:disabled {
    opacity: 0.3;
  }
`

export const LoginButton = styled(LoginButtonBase)<{ blocked?: boolean }>`
  width: 100%;
  height: 52px;
  font-size: 12px;
  border-radius: 6px;
  margin: auto 0 0 0;
  align-self: flex-end;
  cursor: ${({ blocked }) => (blocked ? 'default' : 'pointer')};
  background: ${({ blocked, theme }) => (blocked ? theme.button_blocked_color : theme.button_color)};
`
